import React from 'react';
export function CourseGoal() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-975">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-976">
        <div className="mb-12" data-id="element-977">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-978">
            Course Goal
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-979">
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-980">
              To develop in the students the basic knowledge, skills and
              attitude essential to the safe and efficient use of a handgun for
              protection of self and family, and to provide information on the
              law-abiding citizen's right to self-defense.
            </p>
          </div>
        </div>
      </div>
    </div>;
}